module.exports = __webpack_public_path__ + "assets/media/template_success.e19fa3f0.mp3";